export default {
  name: "Question",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm0 26C9.38 28 4 22.62 4 16S9.38 4 16 4s12 5.38 12 12-5.38 12-12 12zm1-6c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm4-9c0 2-1.33 3-2.4 3.8-1.02.77-1.6 1.25-1.6 2.2 0 .55-.45 1-1 1s-1-.45-1-1c0-2 1.33-3 2.4-3.8 1.02-.77 1.6-1.25 1.6-2.2-.01-.32-.2-2-3-2-1.56 0-2.53.75-2.89 2.24-.13.54-.67.87-1.21.74-.54-.13-.87-.67-.74-1.21C11.75 10.37 13.51 9 16 9c3.96 0 5 2.62 5 4z",
  },
}
